<template>
  <a
    class="brand-tile"
    :href="url"
  >
    <img
      v-if="image"
      class="brand-tile__image"
      :src="image.src"
      :alt="image.alt"
      :title="image.title"
      :width="image.width"
      :height="image.height"
      loading="lazy"
    >
  </a>
</template>

<script>
  export default {
    props: {
      url: String,
      image: Object,
    }
  }
</script>
